import { useCallback, useEffect, useRef } from 'react'
import useIframePosition from '@v4/hooks/useIframePosition'
import AppStore from '@v4/store/appStore'
import useStyles from './PopupModal.styled'

export const usePopupModal = ({ open, blurred, onClose, children, className, closable = false }) => {
	const parentWindowHeight = AppStore.useStoreState(state => state.general.parentWindowHeight)
	const classes = useStyles()
	const paperRef = useRef(null)

	useEffect(() => {
		const rootEl = document.getElementById('root')
		if (blurred && open && rootEl) rootEl.style.filter = 'blur(15px)'
		return () => {
			if (blurred && open && rootEl) rootEl.style.filter = null
		}
	}, [blurred, open])

	const handleSetModalPosition = useCallback(({ rect, innerHeight }) => {
		const $el = paperRef.current
		if (!$el || !rect || window.parent === window) {
			return
		}

		const { height: modalHeight } = $el.getBoundingClientRect()
		const { height, top, bottom } = rect

		if (
			window.innerHeight <= modalHeight ||
			height <= innerHeight ||
			top >= innerHeight ||
			bottom <= 0 ||
			(top > 0 && bottom < innerHeight)
		) {
			$el.style.marginTop = null
			return
		}

		const maxMarginTop = height - Math.max(innerHeight / 2 + modalHeight / 2, modalHeight)
		const minMarginTop = innerHeight / 2 - Math.min(top, 0) - modalHeight / 2
		const marginTop = Math.min(minMarginTop, maxMarginTop)

		$el.style.marginTop = `${marginTop}px`
	}, [])

	useIframePosition(handleSetModalPosition, open)

	return [
		{
			className,
			classes,
			open,
			children,
			closable,
			paperRef,
			paperStyle: parentWindowHeight
				? {
						'--parent-window-height': `${parentWindowHeight}px`,
				  }
				: undefined,
		},
		{ handleClose: onClose },
	]
}
